import { Box, Button, FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, TextField } from "@mui/material";
import React, { useRef, useState } from "react";

const Form = ({ updateValue }: { updateValue: (value: string) => void }) => {
    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        email: "",
        address1: "",
        address2: "",
        city:"",
        state:"NY",
        zip:"",
        message: "",
        phone:"",
        type:""
      });

    const submitForm = (e:any) =>{
        e.preventDefault();
        fetch(scriptUrl, {method: 'POST', body: new FormData(formRef.current)})
        .then(res => {
            console.log("SUCCESSFULLY SUBMITTED", formData);
            updateValue("false");
            
        })
        .catch(err => console.log(err))
    }
    const handleChange = (e:any) => {
        let { name, value } = e.target; 
        if(typeof value === "string" && name !== 'message'){ value = toTitleCase(value)}
        setFormData({ ...formData, [name]: value }); 

    };

    const toTitleCase = (str:string) => {
      return str.replace(
        /\w\S*/g,
        (text: string) => text.charAt(0).toUpperCase() + text.substring(1).toLowerCase()
      );
    }
    const formRef = useRef<any>(formData)

    const scriptUrl = "https://script.google.com/macros/s/AKfycbzZA42bsnFSPlE-3DCsfxn0b_RlCwXjudxdXXWhZi53LjVGk4LtzEyylw2KIjPWUJap/exec"
    
    return <form className="contact-form"
    method='post'
    onSubmit={submitForm}
    autoComplete="off"
    name="standard-issue-form"
    ref={formRef}
    >
    <Box       
      sx={{
        '& .MuiTextField-root': { m: 0, width: '49%', mr:'1%' },
      }}>
      <TextField
        type="text"
        label="First Name"
        name="firstName"
        variant="filled"
        color='warning'
        required
        value={formData.firstName}
        onChange={handleChange}
        inputProps={{
          pattern: "[A-Za-z ]+",
        }}
      />
      <TextField
        type="text"
        label="Last Name"
        name="lastName"
        variant="filled"
        color='warning'
        required
        onChange={handleChange}
        value={formData.lastName}
        inputProps={{
          pattern: "[A-Za-z ]+",
        }}
      />
    </Box>
    <Box       
      sx={{
        '& .MuiTextField-root': { m: 0, width: '49%', mr:'1%' },
      }}>
      <TextField
        type="email"
        label="Email"
        name="email"
        variant="filled"
        color='warning'
        required 
        onChange={handleChange}
        value={formData.email}
        inputProps={{ 
          pattern: "^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+.[A-Za-z]{2,4}$" 
        }}
      />
      <TextField
        type="tel"
        label="Phone"
        name="phone"
        variant="filled"
        color='warning'
        required
        onChange={handleChange}
        value={formData.phone}
        inputProps={{ 
          pattern: "^d{3}-d{3}-d{4}$|^d{10}$^[\+]?[0-9]{0,3}\W?+[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$" 
        }}
      />
    </Box>
    <TextField
      sx={{m: 0, width: '99%', mr:'1%'}}
        type="text"
        label="Street Address"
        name="address1"
        variant="filled"
        color='warning'
        onChange={handleChange}
      value={formData.address1}
    />
    <TextField
      sx={{m: 0, width: '99%', mr:'1%'}}
        type="text"
        label="Street Address 2"
        name="address2"
        variant="filled"
        color='warning'
        onChange={handleChange}
      value={formData.address2}
    />
    <Box       
        sx={{
          '& .MuiTextField-root': { m: 0, width: '32.33%', mr:'1%' },
        }}>
        <TextField
          type="text"
          label="City"
          name="city"
          variant="filled"
          color='warning'
          required
          onChange={handleChange}
          inputProps={{ 
            pattern: "[A-Za-z ]+" 
          }}
        />
                <TextField
          type="text"
          label="State"
          name="state"
          variant="filled"
          value="NY"
          color='warning'
          inputProps={{ 
            readOnly: true
          }}
        />
        <TextField
          type="number"
          label="Zip"
          name="zip"
          variant="filled"
          color='warning'
          onChange={handleChange}
          inputProps={{ 
            pattern: "[0-9]{5}" 
          }}
        />
    </Box>
    <TextField
      sx={{m: 0, width: '99%', mr:'1%'}}
        name="message"
        label="What needs to be done?"
        multiline
        minRows={2}
        maxRows={4}
        variant="filled"
        color='warning'
        required
      onChange={handleChange}
      />
    <FormControl className='plain'>
        <FormLabel id="demo-controlled-radio-buttons-group">Work Type</FormLabel>
        <RadioGroup
          row
          name="type"
          onChange={handleChange}
        >
          <FormControlLabel value="Commercial" control={<Radio />} label="Commercial" />
          <FormControlLabel value="Residential" control={<Radio />} label="Residential" />
        </RadioGroup>
    </FormControl>
    <Button 
        variant='contained'
        type="submit" 
        color='secondary'
        sx={{m: 0, width: '99%', mr:'1%'}}>
        Submit
    </Button>
    </form>
  }

  export default Form;